import React from 'react';
import { masterGuideChapters, masterGuideStats } from '../data/content';
export function MasterGuide() {
  return <section className="bg-ivory-light py-11 sm:py-16" aria-labelledby="master-guide-title" data-id="element-103" data-mp="12pxj5nr0dazi">
      <div className="mx-auto max-w-5xl px-5 sm:px-8" data-id="element-104" data-mp="1gposhb6ky376">
        <div className="mx-auto max-w-2xl text-center" data-id="element-105" data-mp="1gmasg9le262w">
          <h2 id="master-guide-title" className="font-display text-[25px] font-semibold uppercase leading-[1.1] tracking-tightish text-navy-deep sm:text-4xl" data-id="element-106" data-mp="1bossh8pcn171">
            One master guide.
            <br data-id="element-107" data-mp="1llno9ju8mnhm" />
            An entire clinical system inside.
          </h2>
          <p className="mx-auto mt-3.5 max-w-xl text-[14px] leading-snug text-navy-soft sm:text-base" data-id="element-108" data-mp="1zen1ff6js5m0">
            170 pages of practical, evidence-informed speech therapy resources designed to help you
            move from assessment and clinical reasoning to goals, activities, complete sessions,
            progress monitoring and documentation.
          </p>
          <p className="mx-auto mt-3 max-w-lg text-[10.5px] font-semibold uppercase leading-relaxed tracking-[0.14em] text-teal sm:text-xs" data-id="element-109" data-mp="1nsc8hhseel37">
            13 practical clinical chapters • Ready-to-adapt resources • Built for real practice
          </p>
        </div>

        <ul className="mt-7 grid grid-cols-1 gap-3 sm:mt-9 sm:grid-cols-2 sm:gap-4 lg:grid-cols-3" data-id="element-110" data-mp="1wuty8679hvuy">
          {masterGuideChapters.map(chapter => <li key={chapter.number} className="flex h-full flex-col rounded-xl border border-navy/10 bg-ivory p-4 shadow-card sm:p-5" data-id="element-111" data-mp="26plxrfkemssd">
              <p className="font-display text-[15px] font-semibold text-gold sm:text-base" data-id="element-112" data-mp="2gfyf6ywxa5ua">
                {chapter.number}
              </p>
              <h3 className="mt-1.5 text-[13px] font-semibold uppercase leading-tight tracking-[0.04em] text-navy-deep sm:text-sm" data-id="element-113" data-mp="2kha5z7rj8x42">
                {chapter.title}
              </h3>
              <p className="mt-1.5 text-[12.5px] leading-snug text-navy-soft sm:text-[13.5px]" data-id="element-114" data-mp="2uh137h7h9q7u">
                {chapter.detail}
              </p>
            </li>)}
        </ul>

        <dl className="mt-6 grid grid-cols-3 gap-y-5 rounded-xl bg-navy-deep px-4 py-5 text-center text-ivory-light sm:mt-8 sm:grid-cols-5 sm:px-6 sm:py-6" data-id="element-115" data-mp="pfycztdvfil1">
          {masterGuideStats.map(stat => <div key={stat.label} data-id="element-116" data-mp="zc1lri38afgy">
              <dt className="font-display text-[26px] font-semibold leading-none text-gold-light sm:text-4xl" data-id="element-117" data-mp="zb02iqc26mo5">
                {stat.value}
              </dt>
              <dd className="mx-auto mt-1.5 max-w-[9rem] text-[10px] font-semibold uppercase leading-tight tracking-[0.12em] text-ivory/70 sm:text-[11px]" data-id="element-118" data-mp="191upjwx4pqan">
                {stat.label}
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}